class Patients {
    constructor(options){
        if(options){
            this.client = options.client
        }
    }
    fetch(options){
        return this.client.get('/patients', options)
    }
    create(options){
        return this.client.post('/patients', options)
    }
    update(options){
        return this.client.put(`/patients/${options.id}`, options)
    }
}

export default Patients


// WEBPACK FOOTER //
// ./lib/apiClient/patients.js